<script>
    import {onDestroy, onMount} from 'svelte';
    import {Route, navigateTo} from 'svelte-router-spa';
    import {PRConnect} from "@projectroom/ui-lib";
    import Plan from './../components/Plan.svelte';
    import { planStore } from "./store/plan-store";
	import { accessToken } from './store/auth-store';
	import AccountMenu from './common/AccountMenu.svelte';
	import { ThemeToggle } from '../lib/ui';

    export let currentRoute;
    export let params = {};

    let isAccountPanel = false;
    let emailId;
    let authType;
	let planStoreSubsc;

    onMount(() => {
		planStoreSubsc = planStore.subscribe(message => {
            emailId = message?.emailId;
			authType = message?.authType;
        });
    });
     
    onDestroy(() => {
		planStoreSubsc();
    });

    const clickLogout = () => {
        PRConnect.send("/api/Auth/logout", {}, data => {
            if (data.header.status === "success") {
				accessToken.set(null);
				planStore.setInitializeFlag();
                navigateTo("/login");
            }
        });
    }

</script>
<div id="main-layout" class="wrap" on:click={()=> isAccountPanel = false}>
    <header class="header">
        <div class="inner">
            <div data-collapse="small" data-animation="default" data-duration="400" data-easing="ease"
                data-easing2="ease" data-doc-height="1" role="banner" class="avatalk-menu w-nav">
                <div class="avatalk-logo">
                    <a class="avatalk-link" on:click={()=>navigateTo("/")}></a>
                </div>

                <nav class="console-nav">
                    <a class="console-nav-link console-nav-home" on:click={()=>navigateTo("/main")} aria-label="홈">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                            <polyline points="9 22 9 12 15 12 15 22"/>
                        </svg>
                    </a>
                </nav>

                <div class="acct-wrap">
                    <ThemeToggle />
                    <div class="tw-h-4 tw-w-px tw-bg-border"></div>
                    <AccountMenu />
                </div>
            </div>
        </div>
    </header>
    <Plan />
    <Route {currentRoute} {params}/>
</div>
<style>
	.avatalk-logo {
		cursor: pointer;
	}

	/* 콘솔 전역 네비(최소 버전). 이후 shadcn 좌측 사이드바 셸로 이관 예정. */
	.console-nav {
		display: flex;
		align-items: center;
		gap: 18px;
		margin-left: 28px;
	}
	.console-nav-link {
		cursor: pointer;
		font-size: 14px;
		font-weight: 600;
		color: #3a4152;
		white-space: nowrap;
	}
	.console-nav-link:hover {
		color: #1c2333;
	}
	.console-nav-home {
		display: inline-flex;
		align-items: center;
	}
	.console-nav-home svg {
		width: 22px;
		height: 22px;
		display: block;
	}

	/* 헤더 콘텐츠 폭을 앱 공용 상한(--app-max-w)과 통일 (webflow 1280 오버라이드) */
	.inner {
		max-width: var(--app-max-w);
	}
	.avatalk-menu {
		max-width: var(--app-max-w);
		align-items: center;
	}

	/* ===== 계정(우측 상단) — 공용 AccountMenu 컴포넌트 사용 ===== */
	.acct-wrap {
		display: flex;
		align-items: center;
		gap: 12px;
		/* 로고/네비 뒤로 밀어 헤더 오른쪽 끝에 정렬 */
		margin-left: auto;
	}

	/* 다크 모드에서 헤더/캔버스 톤 정합 */
	:global(.dark) #main-layout {
		background: hsl(var(--sb-background));
	}
	:global(.dark) .header {
		background: hsl(var(--sb-background));
		border-color: hsl(var(--sb-border));
	}
	:global(.dark) .console-nav-link {
		color: hsl(var(--sb-foreground) / 0.8);
	}
	:global(.dark) .console-nav-link:hover {
		color: hsl(var(--sb-foreground));
	}
</style>